import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { ProjectsProvider } from './contexts/ProjectsContext';
import { LanguageProvider } from './contexts/LanguageContext';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <LanguageProvider>
      <ProjectsProvider>
        <App />
      </ProjectsProvider>
    </LanguageProvider>
  </StrictMode>
);